import React from 'react';
import List, { TAB_TYPE } from './index';

const Company = (props) => {
  return (<List {...props} mode={TAB_TYPE.company} />);
};

export default Company;
